export const onboardingFlowRoutes = {
  slides: "slides",
  userProfile: "user-profile",
  groups: "groups",
  helpCategories: "help-categories",
} as const;
